module.exports = __webpack_public_path__ + "img/dashboard.1e6c1861.svg";